import { Injectable } from '@angular/core';
import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';
import { ApplianceDetailsFacade } from '@modules/appliance-details/appliance-details.facade';
import { ApplianceTypeEnums } from '@modules/appliance-details/models/appliance-type.enum';
import { ApplianceDetailsQuery } from '@modules/appliance-details/state/appliance-details.query';
import { ApplianceDetailsStore } from '@modules/appliance-details/state/appliance-details.store';
import { ProcedureConfigurationService } from '@modules/order/services/procedure-configuration.service';
import { OrderQuery } from '@modules/order/state/order-query';
import { IdName } from '@shared/models/id-name';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { enumEquals } from '@shared/utils/enum-utils';

export interface IntuitiveApplianceDetailsFormState {
	applianceType: IdName;
	isUpperChecked: boolean;
	isLowerChecked: boolean;
}

@Injectable()
export class IntuitiveApplianceDetailsFacade extends ApplianceDetailsFacade {
	procedureTitle$: Observable<string> = this.procedureConfigurationService.procedures$.pipe(
		map(procedures => procedures.find(p => enumEquals(p.Id, ProcedureEnum.Appliance))?.Name ?? ''),
		shareReplay({ bufferSize: 1, refCount: true })
	);

	constructor(
		protected readonly applianceDetailsStore: ApplianceDetailsStore,
		protected readonly applianceDetailsQuery: ApplianceDetailsQuery,
		protected readonly orderQuery: OrderQuery,
		protected readonly shellQuery: ShellQuery,
		private readonly procedureConfigurationService: ProcedureConfigurationService
	) {
		super(applianceDetailsStore, applianceDetailsQuery, shellQuery, orderQuery);
	}

	updateApplianceDetails(params: IntuitiveApplianceDetailsFormState) {
		this.applianceDetailsStore.update({
			isUpperChecked: params.isUpperChecked,
			isLowerChecked: params.isLowerChecked,
			applianceType: params.applianceType ? params.applianceType : { Id: ApplianceTypeEnums.Empty, Name: '' }
		});
	}
}
